import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import { Option } from '../Option';
import { Modal } from '../Modal';
import { Portal } from '../Portal';
import clsx from 'clsx';
const Menu = ({ options, selected, onSelect, closeOnSelect = true, setOpen, parent, positioning, interpolation = {}, menuStyles = {}, modalStyles = {}, customClassName = '', modalClassName = '', modalProps = {}, }) => {
    const classes = useStyles();
    const innerContainerStyle = clsx({
        [classes.innerContainer]: true,
        [customClassName]: Boolean(customClassName)
    });
    const onSelectOption = option => {
        onSelect(option);
        if (closeOnSelect)
            setOpen(false);
    };
    const composedModalProps = Object.assign({ parent,
        positioning,
        setOpen, customClassName: modalClassName, interpolation, inlineStyles: modalStyles }, modalProps);
    return (React.createElement(Portal, null,
        React.createElement(Modal, Object.assign({}, composedModalProps),
            React.createElement("div", { className: innerContainerStyle, style: menuStyles }, options.map(option => (React.createElement(Option, { key: option.id, option: option, onSelectOption: onSelectOption, active: option.id === (selected === null || selected === void 0 ? void 0 : selected.id) })))))));
};
Menu.propTypes = {
    options: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.shape({
        id: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        handler: PropTypes.func
    }),
    closeOnSelect: PropTypes.bool,
    setOpen: PropTypes.func.isRequired,
    parent: PropTypes.instanceOf(Element),
    positioning: PropTypes.object,
    interpolation: PropTypes.object,
    menuStyles: PropTypes.object,
    modalStyles: PropTypes.object,
    customClassName: PropTypes.string,
    modalClassName: PropTypes.string,
    modalProps: PropTypes.shape({
        setOpen: PropTypes.func.isRequired,
        parent: PropTypes.instanceOf(Element),
        positioning: PropTypes.shape({
            anchor: PropTypes.shape({
                x: PropTypes.oneOf(['left', 'center', 'right']).isRequired,
                y: PropTypes.oneOf(['top', 'center', 'bottom']).isRequired
            }),
            offset: PropTypes.shape({
                x: PropTypes.number.isRequired,
                y: PropTypes.number.isRequired
            })
        }),
        customClassName: PropTypes.string,
        interpolation: PropTypes.object,
        node: PropTypes.string
    })
};
export { Menu };
//# sourceMappingURL=Menu.js.map